<template>
  <b-card  :class=" 'cardSe' " style="width: 110%; margin-left: -44px;">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="text-left">
      <span style="color: #8CACC2; font-size: 11px"> Tratamientos a presentar </span>
    </div>

    <div style="height: 400px">
      <div style="height: 370px; overflow-y: scroll;">
      <table id="tablaInvNoIni" style="width: 100%" >
        <thead>
        <tr class="text-left">
          <th class="leterSize bordeTable text-left" >Tratamiento</th>
          <th class="leterSize bordeTable text-center" >Unidades dentales</th>
        </tr>
        </thead>
      </table>
          <div v-for="(tr, indx) in noIniciadosNoInvertidosProp" :key="'tp-'+indx"
               style=" width: 90%; padding-left: 10px; "
          >
            <b-row
                   v-for="(pad, i) in tr.listPadecimientos.filter(lp => lp.estatus == 1)" :key="'pad-'+i">
              <b-col class="leterSize text-left" style="padding-top: 8px;">
                {{pad.tratamiento}}
              </b-col>
              <b-col class="leterSize text-center" style="padding-top: 8px;" >
                {{pad.numeroDiente}}
              </b-col>
            </b-row>
          </div>

        <div v-for="(tr, indx) in hallazgosAdicionalesProp" :key="'tha-'+indx"
             style=" width: 90%; padding-left: 10px;"
        >
          <b-row
              v-for="(pad, i) in tr.listPadecimientos.filter(lp => lp.estatus == 1)" :key="'pad-h-'+i">
            <b-col class="leterSize text-left" style="padding-top: 8px;">
              {{pad.tratamiento}}
            </b-col>
            <b-col class="leterSize text-center" style="padding-top: 8px;" >
              {{pad.numeroDiente}}
            </b-col>
          </b-row>
        </div>

        <div v-for="(tr, indx) in listPadecimientosAgregarProp" :key="'tha12-'+indx"
             style=" width: 90%; padding-left: 10px;"
        >
          <b-row v-if="tr.idKit != null">
            <b-col class="leterSize text-left" style="padding-top: 8px;" >
              {{tr.nombreKit}}
            </b-col>
            <b-col class="leterSize text-center" style="padding-top: 8px;" >
              <span>{{tr.numeroDiente}} <span style="color: #FFFFFF"> {{tr.idDiente}}</span> </span>
            </b-col>
          </b-row>


          <b-row v-else
              v-for="(pad, i) in tr.listaTratamientos" :key="'pad-h12-'+i">
            <b-col class="leterSize text-left" style="padding-top: 8px;" >
              {{pad.nombreTratamiento}}
            </b-col>
            <b-col class="leterSize text-center" style="padding-top: 8px;" >
              {{pad.numeroDiente}}
            </b-col>
          </b-row>
        </div>



        <div v-for="(tr, indxCa) in listatratamientosCambiadosProp" :key="'tcam-'+indxCa"
             style=" width: 90%; padding-left: 10px;"
        >
          <b-row>
            <b-col class="leterSize text-left" style="padding-top: 8px;">
              {{tr.nombreTratamiento}}
            </b-col>
            <b-col class="leterSize text-center" style="padding-top: 8px;" >
              {{tr.numeroDiente}}
            </b-col>
          </b-row>
        </div>

      </div>
      <div>
        <b-button variant="info"
                  size="sm" pill
                  @click="guardarEdicion()"
        >Guardar
        </b-button>
      </div>

    </div>
  </b-card>
</template>

<script>
export default {
  name: "TratsPresentarEdicion",
  props: {
    noIniciadosNoInvertidosProp: Array,
    hallazgosAdicionalesProp: Array,
    listPadecimientosAgregarProp: Array,
    listatratamientosCambiadosProp: Array,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    guardarEdicion(){
        this.$emit("guardarEdicion", )
    }
  }
}
</script>

<style scoped>
.leterSize{
  font-size: 10px !important;
  color: #4F4F4F;
}
.bordeTable{
  border-bottom: #ECECEC 1px solid;
}
</style>